import { DialogActions as MuiDialogActions } from '@mui/material';
export const DialogActions = MuiDialogActions;
